import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { getContactList } from "../Redux/Actions/adminAction";
import Pagination from "../Components/Layout/Pagination";

const capitalize = (str) =>
  str ? str.charAt(0).toUpperCase() + str.slice(1) : "-";

const truncateWords = (str, wordLimit = 30) => {
  if (!str) return "-";
  const words = str.trim().split(/\s+/);
  return words.length > wordLimit
    ? words.slice(0, wordLimit).join(" ") + "..."
    : str;
};

export default function ContactList() {
  const dispatch = useDispatch();
  const { contactList: data, loading } = useSelector(
    (state) => state.usermgmtData
  );

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);

  useEffect(() => {
    dispatch(getContactList({ page, limit, search }));
  }, [dispatch, page, limit, search]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value, 10));
    setPage(1);
  };

  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top">
          <h2>Contact</h2>
        </div>
        <hr />
        <Container fluid>
          <div className="cmn-top-fields">
            <Row>
              <Col xxl={3} xl={3} lg={4} md={4}>
                <Form.Group>
                  <Form.Control
                    type="search"
                    placeholder="Search..."
                    value={search}
                    onChange={handleSearchChange}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        </Container>
        <hr />
      </div>
      <Container fluid>
        <div className="results-sec">
          <Row>
            <Col lg={6} className="d-flex align-items-center">
              <div className="show-results">
                {loading
                  ? "Loading..."
                  : `Showing ${(page - 1) * limit + 1} - ${Math.min(
                    page * limit,
                    data?.totalCount || 0
                  )} of ${data?.totalCount || 0} results`}
              </div>
            </Col>
            <Col lg={6}>
              <div className="select-result d-flex align-items-center justify-content-end">
                <span>Results per page</span>{" "}
                <Form.Select
                  aria-label="Default select example"
                  value={limit}
                  onChange={handleLimitChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Container fluid className="px-0">
        <div className="table-responsive">
          <Table size="sm" className="table-cmn">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Name</th>
                <th>Email</th>
                <th>subject</th>
                <th>Message</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {data?.contacts?.length > 0 ? (
                data.contacts.map((contact, index) => (
                  <tr key={contact._id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>{capitalize(contact.full_name)}</td>
                    <td>{contact.email || "-"}</td>
                    <td>{truncateWords(contact.subject)}</td>
                    <td>{truncateWords(contact.message)}</td>
                    <td>
                      {contact.createdAt
                        ? new Date(contact.createdAt).toLocaleDateString(
                          "en-GB",
                          { day: "2-digit", month: "2-digit", year: "numeric" }
                        )
                        : "-"}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center">
                    No contacts found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>

        {data?.totalPages > 0 && (
          <Pagination
            totalstuff={data?.totalPages}
            limit={data?.limit}
            setpages={setPage}
          />
        )}
      </Container>
    </Layout>
  );
}
